import axios, {AxiosResponse} from 'axios'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {ICorporateModel} from '../corporate/CorporateModel'
import {IUserCorporatesModel} from './UserCorporateModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const ADMIN_URL = `${API_URL}api/v1/corporate/admin/`

export function searchUsersWithCorporates(
  q: string,
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<IUserCorporatesModel>>>> {
  return axios.get(`${ADMIN_URL}users`, {params: {...(q ? {q} : {}), page, size}})
}

export function loadCorporateOptions(): Promise<AxiosResponse<ApiResponse<ICorporateModel[]>>> {
  return axios.get(`${ADMIN_URL}options`)
}

export function assignCorporateToUser(userId: string, corporateId: string, defaultCorporate: boolean) {
  return axios.post(`${ADMIN_URL}user/${userId}/corporates`, {corporateId, defaultCorporate})
}

export function removeCorporateFromUser(userId: string, corporateId: string) {
  return axios.delete(`${ADMIN_URL}user/${userId}/corporates/${corporateId}`)
}
